var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.998 5V8V11H15.498M19.998 10C19.998 11.1819 19.7653 12.3522 19.313 13.4442C18.8607 14.5361 18.1977 15.5282 17.362 16.364C16.5263 17.1997 15.5341 17.8626 14.4422 18.3149C13.3503 18.7672 12.1799 19 10.998 19C9.81615 19 8.64583 18.7672 7.5539 18.3149C6.46197 17.8626 5.46981 17.1997 4.63409 16.364C3.79836 15.5282 3.13542 14.5361 2.68313 13.4442C2.23084 12.3522 1.99805 11.1819 1.99805 10C1.99805 7.61305 2.94626 5.32387 4.63409 3.63604C6.32191 1.94821 8.6111 1 10.998 1C13.385 1 15.6742 1.94821 17.362 3.63604C19.0498 5.32387 19.998 7.61305 19.998 10Z",
    stroke: "#F66700",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.07ef8518e1d1af01cb953c8f9abd377b.svg";
export { ForwardRef as ReactComponent };